<template>
	<div>
		<el-divider>友情链接</el-divider>
		<el-button type="warning" size="mini" icon="el-icon-edit" @click="addLink('')">添加友链</el-button>
		<el-button-group>
			<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
			<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
		</el-button-group>
		<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteAttr">删除</el-button>
		<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getLinkList">刷新</el-button>
		<el-dropdown trigger="click">
			<el-button type="success" icon="el-icon-setting" size="mini">
				设置
				<i class="el-icon-arrow-down el-icon--right"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item v-for="(items, index) in setList" :key="index">
					<el-dropdown trigger="hover" placement="right-start" @command="setCommand">
						<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item
								icon="el-icon-caret-right"
								v-for="(item, index) in items.seconds"
								:key="index"
								:command="{ setParam: items.paramValue, setParamVal: item.val }"
							>
								{{ item.label }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-table
			:data="linkList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="lid"
			:stripe="true"
			:default-sort="{ prop: 'pid', order: 'ascending' }"
			@selection-change="selectChange"
			tooltip-effect="dark"
			ref="multipleTable"
		>
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop="lid" label="序号" width="80" sortable></el-table-column>
			<el-table-column prop="pid" label="排序" width="80" sortable></el-table-column>
			<el-table-column prop="title" label="友链名称"></el-table-column>
			<el-table-column prop="linkurl" label="链接地址"></el-table-column>
			<el-table-column prop="isclass" label="启用状态">
				<template slot-scope="scope">
					<i :class="scope.row.isclass ? 'el-icon-unlock color-green' : 'el-icon-lock color-red'"></i>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button type="warning" size="mini" @click="addLink(scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="友链管理" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
			<el-form class="text-left" ref="attrForm" :rules="rules" :model="linkScope">
				<el-form-item label="链接名称" :label-width="formLabelWidth" prop="title">
					<el-input v-model="linkScope.title" autocomplete="off" placeholder="请输入链接名称,长度2-50个字符"></el-input>
				</el-form-item>
				<el-form-item label="链接地址" :label-width="formLabelWidth" prop="linkurl">
					<el-input v-model="linkScope.linkurl" autocomplete="off" placeholder="请输入链接地址,2-150个字符"></el-input>
				</el-form-item>
				
				<el-form-item label="链接logo" :label-width="formLabelWidth" prop="logo">
					<el-button v-if="!linkScope.logo" size="small" type="primary" @click="addPic">上传图片</el-button>
					<div v-else class="upfile">
						<div class="delicon text-right"><i class="el-icon-delete" @click="delAdscopeImg"></i></div>
						<img v-if="linkScope.logo" :src="HOST + linkScope.logo" alt="" style="width: 150px;height: 150px;" />
					</div>
				</el-form-item>
				<!-- 图片上传组件 -->
				<pic-list ref="piclist" :appendtobody="true" @confirm="chooseIcomComfirm"></pic-list>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitRuleForm('attrForm')">确 定</el-button>
			</div>
		</el-dialog>		
	</div>
</template>
<script>
import Sortable from 'sortablejs';
import picList from '../../components/piclist/piclist.vue';
export default {
	name: '',
	components:{
		picList
	},
	data() {
		return {
			linkList: [],
			selectedLinkIds: [],
			setList: [
				{
					label: '启用状态',
					paramValue: 'isclass',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			setParam: '',
			setParamVal: '',
			dialogVisible: false,
			linkScope: {
				title: '', //链接名
				linkurl: '', //链接地址
				logo: '', //图标
			},
			rules: {
				title: [{ required: true, message: '请输入链接名称', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				linkurl: [{ required: true, message: '请输入链接地址', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 150 个字符', trigger: 'blur' }]
			},
			formLabelWidth: '120px',
			defaultAttrList: [],
			validateList: [
				{
					va_label: '长度限制',
					va_val: '^.{2,200}$'
				},
				{
					va_label: '数字',
					va_val: '^[0-9.-]+$'
				},
				{
					va_label: '整数',
					va_val: '^[0-9-]+$'
				},
				{
					va_label: '小写字母',
					va_val: '^[a-z]+$'
				},
				{
					va_label: '数字+字母',
					va_val: '^[0-9a-z]+$'
				},
				{
					va_label: 'Email',
					va_val: '^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$'
				},
				{
					va_label: 'QQ',
					va_val: '^[0-9]{5,20}$'
				},
				{
					va_label: '超链接',
					va_val: '^http:\\/\\//$'
				},
				{
					va_label: '手机号码',
					va_val: '^(1)[0-9]{10}$'
				},
				{
					va_label: '电话号码',
					va_val: '^[0-9-]{6,13}$'
				},
				{
					va_label: '邮政编码',
					va_val: '^[0-9]{6}$'
				}
			],
			typeList: [
				{
					ty_label: '单行文本',
					ty_val: 'string'
				},
				{
					ty_label: '多行文本',
					ty_val: 'htmltext'
				},
				{
					ty_label: '编辑器',
					ty_val: 'editor'
				},
				{
					ty_label: 'HTML文本',
					ty_val: 'htmltext'
				},
				{
					ty_label: '整数类型',
					ty_val: 'int'
				},
				{
					ty_label: '小数类型',
					ty_val: 'decimal'
				},
				{
					ty_label: '日期类型',
					ty_val: 'date'
				},
				{
					ty_label: '时间类型',
					ty_val: 'time'
				},
				{
					ty_label: '日期时间类型',
					ty_val: 'datetime'
				},
				{
					ty_label: '图片附件',
					ty_val: 'img'
				},
				{
					ty_label: '文件附件',
					ty_val: 'doc'
				},
				{
					ty_label: '视频附件',
					ty_val: 'video'
				},
				{
					ty_label: '下拉框',
					ty_val: 'selectinput'
				},
				{
					ty_label: '单选框',
					ty_val: 'redioinput'
				},
				{
					ty_label: '复选框',
					ty_val: 'checkboxinput'
				},
				{
					ty_label: '复合选项关联输入框',
					ty_val: 'complexinput'
				},
				{
					ty_label: '价格',
					ty_val: 'decimalstring'
				}
			],
		};
	},
	mounted() {
		this.getLinkList();
	},
	methods: {
		getLinkList() {
			this.$axios({
				url: this.HOST + '/admin.module/linkList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.linkList = res.data.list;
						let that = this;
						this.rowDrop(that); // 行拖拽排序
					}
				})
				.catch(err => {});
		},
		selectChange(selection) {
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].lid);
			}
			this.selectedLinkIds = arr;
			console.log(this.selectedLinkIds);
		},
		// 全选
		selectAll() {
			this.linkList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
			// this.selectedLinkIds = this.docIds;
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.linkList.map(item => {
				if (this.selectedLinkIds.indexOf(item.lid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.lid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedLinkIds = diff;
			console.log(this.selectedLinkIds);
		},
		// 操作
		setCommand(command) {
			console.log('set:', command);
			this.setParam = command.setParam;
			this.setParamVal = command.setParamVal;
			this.setAttrClass();
		},
		deleteAttr() {
			if (!this.selectedLinkIds.length) {
				this.$message.error('尚未选中任何友链！');
				return false;
			}
			this.$confirm('是否要删除所选友链？一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.module/deleteLink',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							linkIds: this.selectedLinkIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getLinkList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		setAttrClass() {
			if (!this.selectedLinkIds.length) {
				this.$message.error('尚未选中任何友链！');
				return false;
			}
			this.$axios({
				url: this.HOST + '/admin.module/setLinkClass',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					linkIds: this.selectedLinkIds,
					setParam: this.setParam,
					setParamVal: this.setParamVal
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.getLinkList();
					}
				})
				.catch(err => {});
		},
		// 行拖拽排序
		rowDrop(that) {
			// 此时找到的元素是要拖拽元素的父容器
			const tbody = document.querySelector('.el-table__body-wrapper tbody');
			const _this = that;
			Sortable.create(tbody, {
				// 指定父元素下可被拖拽的子元素
				draggable: '.el-table__row',
				onEnd({ newIndex, oldIndex }) {
					const currRow = _this.linkList.splice(oldIndex, 1)[0];
					_this.linkList.splice(newIndex, 0, currRow);
					console.log('行拖拽结果', 'newIndex:' + newIndex, 'oldIndex:' + oldIndex, 'currRow:', currRow);
					_this.linkList.map((item, index) => {
						item.pid = index;
					});
					// 调用后台拖拽排序接口
					if(newIndex != oldIndex){
						_this._updateMoveData();
					}
				}
			});
		},
		// 拖拽排序接口
		async _updateMoveData() {
			this.$axios({
				url: this.HOST + '/admin.module/updateLinkSort',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					linkList: this.linkList
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						console.log('已成功重排序');
					}
				})
				.catch(err => {});
		},
		addLink(scope) {
			if (!scope) {
				this.linkScope = {
					title: '', //链接名
					linkurl: '', //链接地址
					logo: '', //logo
				};
			} else {
				console.log(scope);
				this.linkScope = JSON.parse(JSON.stringify(scope));
			}
			this.dialogVisible = true;
		},
		submitRuleForm(formname){
			this.$refs[formname].validate((valid,attr) => {
				if (valid) {
					this.addSubmit();
				} else {
					console.log('error submit!!',attr);
					return false;
				}
			});
		},
		addSubmit() {
			this.$confirm('确定提交？')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.module/addLink',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							linkInfo: this.linkScope
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.dialogVisible = false;
								this.$message.success(res.data.msg);
								this.getLinkList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {
					console.log('取消');
				});
		},
		// 上传图片
		addPic() {
			this.$refs.piclist.show();
		},
		chooseIcomComfirm(e){
			this.linkScope.logo = e.files;
		},
		delAdscopeImg() {
			this.linkScope.logo = '';
			console.log(this.linkScope);
		}
	}
};
</script>
<style>
.el-button + .el-button-group {
	margin-left: 10px;
	margin-right: 10px;
}
.el-table__body-wrapper tbody {
	user-select: none;
}
.el-dialog {
	margin-top: 10vh !important;
}
</style>
